/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { PutApiAdminsIdMutationRequest, PutApiAdminsIdMutationResponse, PutApiAdminsIdPathParams, PutApiAdminsId400, PutApiAdminsId401, PutApiAdminsId403, PutApiAdminsId404, PutApiAdminsId500 } from "../../types/PutApiAdminsId.ts";
import { putApiAdminsIdMutationResponseSchema, putApiAdminsIdMutationRequestSchema } from "../../zod/SuperAdminSchemas/putApiAdminsIdSchema.ts";

function getPutApiAdminsIdUrl({ id }: { id: PutApiAdminsIdPathParams["Id"] }) {
  const res = { method: 'PUT', url: `/api/admins/${id}` as const }  
  return res
}

/**
 * @summary Обновление администратора (Доступно только для суперадмина)
 * {@link /api/admins/:Id}
 */
export async function putApiAdminsId({ id, data }: { id: PutApiAdminsIdPathParams["Id"]; data?: PutApiAdminsIdMutationRequest }, config: Partial<RequestConfig<PutApiAdminsIdMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = putApiAdminsIdMutationRequestSchema.parse(data)  
  
  const res = await request<PutApiAdminsIdMutationResponse, ResponseErrorConfig<PutApiAdminsId400 | PutApiAdminsId401 | PutApiAdminsId403 | PutApiAdminsId404 | PutApiAdminsId500>, PutApiAdminsIdMutationRequest>({ method : "PUT", url : getPutApiAdminsIdUrl({ id }).url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/*+json', ...requestConfig.headers } })  
  return putApiAdminsIdMutationResponseSchema.parse(res.data)
}